/* PDZ CART — "Goes well with" row for the cart drawer and cart page, and the mobile
   checkout bar on the cart page. Loaded on every page (layout/theme.liquid).
   <pdz-cart-recs data-pid data-in-cart data-mode="page" data-title>: Shopify product
   recommendations for the first product in the cart, without products already in the cart. */
(function () {
  'use strict';
  if (window.customElements && customElements.get('pdz-cart-recs')) return;

  var cache = {};
  var SKIP = ['assembly-service', 'gift-wrapping'];

  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R ' + n.join('.');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(src, w) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function load(pid) {
    if (!cache[pid]) {
      cache[pid] = fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { delete cache[pid]; return []; });
    }
    return cache[pid];
  }
  function setCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('#CartCount, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }

  class PdzCartRecs extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var self = this, pid = this.getAttribute('data-pid');
      if (!pid) { this.hidden = true; return; }
      var inCart = (this.getAttribute('data-in-cart') || '').split(',');
      load(pid).then(function (list) {
        var items = list.filter(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          p._v = v;
          return p.available && v && inCart.indexOf(String(p.id)) === -1 && SKIP.indexOf(p.handle) === -1;
        }).slice(0, 6);
        if (!items.length) { self.hidden = true; return; }
        self.render(items);
      });
    }
    render(items) {
      var title = this.getAttribute('data-title') || 'Goes well with';
      var html = '<div class="pdz-recs__head"><p class="pdz-recs__t">' + esc(title) + '</p>' +
        '<span class="pdz-recs__nav"><button type="button" data-dir="-1" aria-label="Previous"><svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" data-dir="1" aria-label="Next"><svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></span></div>' +
        '<ul class="pdz-recs__list" role="list">';
      items.forEach(function (p) {
        var v = p._v, price = v.price, was = v.compare_at_price;
        html += '<li class="pdz-recs__c">' +
          '<a class="pdz-recs__img" href="' + esc(p.url) + '" tabindex="-1"><img src="' + esc(img(p.featured_image, 240)) + '" alt="" loading="lazy" width="120" height="120"></a>' +
          '<a class="pdz-recs__n" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="pdz-recs__p"><b>' + money(price) + '</b>' + (was && was > price ? '<s>' + money(was) + '</s>' : '') + '</span>' +
          '<button type="button" class="pdz-recs__add" data-add="' + v.id + '" aria-label="Add ' + esc(p.title) + ' to cart">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg><span>Add</span></button>' +
          '</li>';
      });
      html += '</ul>';
      this.innerHTML = html;
      this.hidden = false;
      this.addEventListener('click', this.onClick.bind(this));
    }
    onClick(e) {
      var nav = e.target.closest('.pdz-recs__nav button');
      if (nav) {
        var list = this.querySelector('.pdz-recs__list');
        list.scrollBy({ left: Number(nav.getAttribute('data-dir')) * list.clientWidth * 0.8, behavior: 'smooth' });
        return;
      }
      var btn = e.target.closest('[data-add]');
      if (!btn || btn.disabled) return;
      var page = this.getAttribute('data-mode') === 'page';
      var label = btn.querySelector('span');
      btn.disabled = true; btn.classList.add('is-busy'); label.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-add')), quantity: 1 }], sections: page ? undefined : 'cart-drawer', sections_url: location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Error');
          if (page) { location.reload(); return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && res.sections && res.sections['cart-drawer'] && drawer.renderContents) drawer.renderContents(res);
          setCount();
        })
        .catch(function (err) {
          btn.disabled = false; btn.classList.remove('is-busy'); label.textContent = 'Add';
          btn.setAttribute('title', String(err.message || err));
        });
    }
  }
  if (window.customElements) customElements.define('pdz-cart-recs', PdzCartRecs);

  /* Cart page: show the mobile checkout bar only while the real Checkout button is off screen. */
  function cartBar() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('pdz-cart-page');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { document.documentElement.classList.toggle('pdz-cart-btn-seen', en.isIntersecting); });
    });
    var watched = null;
    function watch() {
      var btn = footer.querySelector('#cartCheckout');
      if (btn === watched) return;
      if (watched) io.unobserve(watched);
      watched = btn;
      if (btn) io.observe(btn);
    }
    function count() {
      var m = footer.querySelector('[data-pdz-count]'), t = document.querySelector('[data-pdz-title-count]');
      if (!m || !t) return;
      var n = Number(m.getAttribute('data-pdz-count')) || 0;
      t.textContent = n + (n === 1 ? ' item' : ' items');
    }
    watch();
    new MutationObserver(function () { watch(); count(); }).observe(footer, { childList: true, subtree: true });
  }
  /* keyboard: Enter or Space on the drawer remove button */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches && e.target.matches('cart-remove-button.pdz-cd__rm')) { e.preventDefault(); e.target.click(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cartBar);
  else cartBar();
})();
